<template>
  <div>
    <fieldset>
      <h3 class="modal-title">ADD GROUP APPLICATION</h3>
      <b-form-group :class="{'error-input' : $v.group.groupName.$error}">
        <label for="groupName"> Group Name* </label>
        <j-input
          id="groupName"
          v-model="$v.group.groupName.$model"
          placeholder="Enter group name here"/>
      </b-form-group>
      <b-form-group :class="{'error-input' : $v.group.descName.$error}">
        <label for="descName"> Description* </label>
        <j-textarea
          id="descName"
          v-model="$v.group.descName.$model"
          :disabled="false"
          placeholder="Enter group description here"/>
      </b-form-group>
      <div class="pull-right">
        <b-button
          class="btn"
          @click="closeCreateGroupModal">
          Close
        </b-button>
        <b-button
          class="btn"
          variant="primary"
          @click="createGroup">
          Add
        </b-button>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
  validations() {
    return {
      group: {
        groupName: { required },
        descName: { required },
      },
    };
  },
  data() {
    return {
      group: {
        groupName: null,
        descName: null,
      },
    };
  },
  methods: {
    ...mapActions('jStoreSetting', ['actionCreateGroupApplication']),

    closeCreateGroupModal() {
      this.$emit('modal-open', false);
    },
    async createGroup() {
      this.$v.group.$touch();

      if (!this.$v.group.$error) {
        this.$swal({
          title: `Are you sure to create group application ${this.group.groupName} ?`,
          text: '',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then(async (result) => {
          if (result.value) {
            const parameter = {
              name: this.group.groupName,
              description: this.group.descName,
            };
            const res = await this.actionCreateGroupApplication(parameter);

            if (!res.error) {
              this.$router.replace(`/setting/application/group/${res.data.id}`);
            }
          }
        });
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/setting/jModalCreateGroup.vue